import React from 'react';

export const aLittleLostContent = [
  {
    question: 'What are tokens?',
    answer: (
      <React.Fragment>
        Think of tokens like DAYMADE credit which can be collected and redeemed
        for free entries, <strong>prizes</strong>, and{' '}
        <strong>the planting of trees</strong>.
      </React.Fragment>
    ),
  },
  {
    question: 'How do I earn tokens?',
    answer: (
      <React.Fragment>
        To earn tokens, you'll first need to subscribe to DAYMADE Premium/Lite.
        Then match just <strong>1 number</strong> in one of our Weekly Draw to
        start winning tokens. You'll get 1 token for matching 1 main number or
        bonus number and 2 tokens for matching 1 main number and the bonus
        number.
      </React.Fragment>
    ),
  },
  {
    question: 'How do I exchange my tokens?',
    answer: (
      <React.Fragment>
        You can visit this page (while logged in) to see how many tokens you
        have and what redemption options are available to you.
      </React.Fragment>
    ),
  },
  {
    question: 'What can I exchange my tokens for?',
    answer: (
      <React.Fragment>
        Tokens can be redeemed for entries into our <strong>Weekly Draw</strong>
        , <strong>Daily Raffle</strong> and <strong>Leaderboard Raffle</strong>,
        trees planted with Veritree, and even prizes on our site. We weren't
        lying when we said they were epic!
      </React.Fragment>
    ),
  },
  {
    question: 'Do tokens expire?',
    answer: (
      <React.Fragment>
        Your DAYMADE tokens expire <strong>12 months</strong> after you win your
        last token. After that, your token balance will reset to zero.
      </React.Fragment>
    ),
  },
];
